import React from "react";
import { PropTypes } from "prop-types";
import { Row, Col } from "antd";
import {
  CustomPrimaryButtonWrap,
  ModalHeaderSubText,
} from "../../../../Epics/Grants/Pages/RecommendGrant/Component/GrantPopup/style";
import {
  UnderlyingContent,
  CustomModal,
  ModalHeading,
  CardPopContainer,
} from "../../../../Epics/Grants/Pages/RecommendGrant/style";
import Preloader from "../../../Preloader/Preloader";
import { GeneralButton } from "../../../Commons/commonComponents";

export const getTitle = (props) => (
  <>
    {props.popupTitle && <ModalHeading>{props.popupTitle}</ModalHeading>}
    {props.popupDesc && (
      <ModalHeaderSubText>{props.popupDesc}</ModalHeaderSubText>
    )}
  </>
);

export const getFooter = (props) => {
  return (
    <div>
      <CustomPrimaryButtonWrap>
        <GeneralButton
          id="btnYesMakeANewGrant"
          key="Close"
          onClick={props.primaryCta}
          disabled={!props.enablePrimaryCta}
          type="functional"
          text={props.primaryCtaLabel}
          width="100%"
          mobWidth="100%"
        />
      </CustomPrimaryButtonWrap>
      <UnderlyingContent onClick={props.onCancel}>
        {props.secondaryCtaLabel}
      </UnderlyingContent>
    </div>
  );
};

export default function Popup(props) {
  return (
    <CustomModal
      title={[getTitle(props)]}
      visible={props.show}
      onCancel={props.onCancel}
      footer={[getFooter(props)]}
      width="895px"
      padding="0 0 30px 0"
    >
      <Row>
        <Col lg={24} md={0} xs={0}>
          {props.loading ? <Preloader /> : <>{props.renderDesktop}</>}
        </Col>
        <Col lg={0} md={24} xs={24}>
          <CardPopContainer>
            {props.loading ? <Preloader /> : <>{props.renderMobile}</>}
          </CardPopContainer>
        </Col>
      </Row>
    </CustomModal>
  );
}

Popup.propTypes = {
  enablePrimaryCta: PropTypes.bool,
  loading: PropTypes.any,
  onCancel: PropTypes.func,
  popupDesc: PropTypes.string,
  popupTitle: PropTypes.string,
  primaryCta: PropTypes.func,
  primaryCtaLabel: PropTypes.string,
  renderDesktop: PropTypes.object,
  renderMobile: PropTypes.array,
  secondaryCtaLabel: PropTypes.string,
  show: PropTypes.bool,
};
